import * as yup from 'yup';
import { ISuggestion, SuggestionSchema } from '../../../common';

export const WoundAttachmentSuggestionSchema = yup.object({
  documentTypes: SuggestionSchema.nullable(),
});

export type IWoundAttachmentSuggestion = {
  documentTypes: ISuggestion;
};
